import {Params} from '@angular/router';
import {createSelector} from '@ngrx/store';
import {RouterReducerState} from '@ngrx/router-store';
import {selectRouterState} from '../core.state';

export interface RouterStateUrl {
  url: string;
  prevUrl: string;
  params: Params;
  queryParams: Params;
}

export const SelectCurrentUrl = createSelector(
  selectRouterState,
  (state: RouterReducerState<RouterStateUrl>) => state?.state?.url || null
);

export const SelectPrevUrl = createSelector(
    selectRouterState,
    (state: RouterReducerState<RouterStateUrl>) => state?.state?.prevUrl || null
);

export const SelectBackButtonDefaultHref = createSelector(
  SelectPrevUrl,
  // (prevUrl: string) => prevUrl?.split('/')[1] ?? 'home'
  (prevUrl: string) => prevUrl ?? 'home'
);

export const SelectCurrentUrlParams = createSelector(
  selectRouterState,
  (state: RouterReducerState<RouterStateUrl>) => state.state.params
);

export const SelectCurrentUrlQueryParams = createSelector(
  selectRouterState,
  (state: RouterReducerState<RouterStateUrl>) => state.state.queryParams
);

export const SelectUrlStateForError = createSelector(
  selectRouterState,
  (state: RouterReducerState<RouterStateUrl>) => ({
    url: state.state.url,
    prevUrl: state.state.prevUrl,
    params: state.state.params,
    queryParams: state.state.queryParams
  })
);
